<template>
    <div class="v-list">
        <div class="v-list__group">
            <attachment :attachment="attachment" v-show="!(index > 3 && !hiddenList)" v-for="(attachment, index) in attachments" :key="attachment.id"></attachment>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Attachment from "./Attachment";

    export default {
        name: 'Attachments',
        components: {Attachment},
        computed: {
            ...mapState(['consultation']),

            ...mapState('attachment', [
                'attachments',
                'hiddenList'
            ]),
        },
        mounted() {
            window.echo.private('consultation.room.' + this.consultation.id).listen('Attachments.AddAttachment', ({attachment}) => {
                this.addAttachment(attachment);
            });

            window.echo.private('consultation.room.' + this.consultation.id).listen('Attachments.DeleteAttachment', ({attachment}) => {
                this.spliceAttachments(attachment.id);
            });

            this.getAttachments();
        },
        methods: {
            ...mapActions('attachment', [
                'getAttachments',
            ]),
            ...mapMutations('attachment', [
                'addAttachment',
                'spliceAttachments'
            ])
        }
    }
</script>
